import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice";
import store from "app/redux/store/store";
import { ControllerBase } from "controllerBase";
const ko = require('knockout')
import global from 'globalMU'
import { Paginator } from "paginator";


declare var window:any

export const ProfissionalOrcamentoController = ControllerBase.extend({
    name: "ProfissionalOrcamentoController",

    framework: "knockout",

    ajax: function() {

        return {
            url: "/Orcamento/_Profissional",
            type: "post",
            cache: false
        };
    },

    newModel: function() {
        return {
            Codigo: null,
            Nome: null,
            Observacao: null,
            ProfissionaisOrcamento: [],
            Profissionais: [],
            ProfissionaisSelecionados: [],
            ProfissionaisOrcamentoSelecionados: [],
            incluir: true,
            tipos: [{ text: "Interno", value: false }, { text: "Externo", value: true }]
        };
    },

    antesBinding: function() {

        if (this.orcamento.get("Profissionais")) {
            var m = ko.mapping.fromJS(this.orcamento.get("Profissionais"));
            this.model.ProfissionaisOrcamento(m());
            this.model.incluir(false);
        }

    },

    alterarExterno: function(model) {

        if (!model.selecionado()) {
            model.selecionado(model.Externo() != null && model.Externo() != undefined && model.Externo() != "");

            if (model.selecionado()) {
                this.model.ProfissionaisSelecionados.push(model);
            } else {
                this.model.ProfissionaisSelecionados.remove(model);
            }
        }

    },

    antesRenderizacaoCompleta: function() {

        this.botaoLimpar = this.addActionButton({
                text: "Limpar",
                'class': "icone-excluir separador",
                click: $.proxy(function() {

                        this.limpar();

                    },
                    this)
            },
            true);


    },

    aposBinding: function () {
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },


    limpar: function() {

        global.clearFormFields({ element: this.form });
        this.model.Profissionais(undefined);

    },

    formConfig: {
        selector: "#form-profissionais",
        submit: {
            selector: "#bntPesquisar",
            loadingText: "Aguarde...",
            callback: "pesquisar",
            type: "model",
            modelType: "knockout"
        },
    },

    cancelar: function() {
        this.model.incluir(false);
    },

    pesquisar: function(model, e, page) {

        var self = this;

        if (e) {
            e.preventDefault();
        }

        var filtros = {
            TamanhoPagina: 20,
            NumeroPagina: page ? page : 1,
            IdentificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
            Codigo: this.model.Codigo(),
            Nome: this.model.Nome()
        };

        this.model.ProfissionaisSelecionados.removeAll();


        global.ajax({
            url: "/Orcamento/ListarProfissionais",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({ filtros: filtros }),
            success: function(data) {

                if (!data) {
                    return;
                }

                var m = ko.mapping.fromJS(data.Entities);

                self.model.Profissionais(m());

                self.paginador = new Paginator({
                    container: "#page-profissional",
                    data: data,
                    pageClickCallback: $.proxy(self.paginar, self)
                });

            }
        });

    },

    paginar: function(e) {
        this.pesquisar(this.model, null, e.page);
    },

    selecionar: function(model) {
        model.selecionado(!model.selecionado());


        if (model.selecionado()) {
            this.model.ProfissionaisSelecionados.push(model);
        } else {
            this.model.ProfissionaisSelecionados.remove(model);
        }

    },

    adicionar: function() {


        if (!this.model.ProfissionaisSelecionados ||
            !this.model.ProfissionaisSelecionados() ||
            this.model.ProfissionaisSelecionados().length == 0) {
            global.showErrorMessage("Selecione o(s) profissional(is) a ser(em) adicionado(s).");
            return;
        }

        var todosTiposSelecionados = true;

        $.each(this.model.ProfissionaisSelecionados(),
            function() {

                if (this.Externo() == null || this.Externo() == undefined || this.Externo() == "") {
                    todosTiposSelecionados = false;
                    return false;
                }

            });

        if (!todosTiposSelecionados) {
            global.showErrorMessage("Informe o tipo de todos os profissionais selecionados.");
            return;
        }

        var self = this;

        var profissionais = this.toJS(this.model.ProfissionaisSelecionados());

        global.ajax({
            url: "/Orcamento/AdicionarProfissionais",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                profissionais: profissionais
            }),
            success: function(data) {

                if (!data) {
                    return;
                }

                if (!data.HasErrors) {
                    global.showSuccessMessage("Profissional(is) adicionado(s) com sucesso");
                }

                var m = ko.mapping.fromJS(data.Profissionais);

                self.model.ProfissionaisOrcamento(m());
                self.orcamento.set("Profissionais", data.Profissionais);
                store.dispatch(sobrescreverInformacoesAction({Profissionais: data.Profissionais}))
                self.model.incluir(false);
                self.model.Profissionais.removeAll();
                self.model.ProfissionaisSelecionados.removeAll();
            }
        });

    },

    selecionarProfissionalOrcamento: function(model) {

        model.selecionado(!model.selecionado());


        if (model.selecionado()) {
            this.model.ProfissionaisOrcamentoSelecionados.push(model);
        } else {
            this.model.ProfissionaisOrcamentoSelecionados.remove(model);
        }

    },

    incluir: function() {
        this.model.incluir(true);
        this.model.Profissionais.removeAll();
        this.model.ProfissionaisSelecionados.removeAll();
    },

    excluir: function() {

        var self = this;

        var profissionais = this.toJS(this.model.ProfissionaisOrcamentoSelecionados());

        global.ajax({
            url: "/Orcamento/RemoverProfissionais",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                profissionais: profissionais
            }),
            success: function(data) {

                if (!data) {
                    return;
                }

                if (!data.HasErrors) {
                    global.showSuccessMessage("Profissional(is) excluído(s) com sucesso");
                }

                var m = ko.mapping.fromJS(data.Profissionais);

                self.model.ProfissionaisOrcamento(m());
                self.orcamento.set("Profissionais", data.Profissionais);
                store.dispatch(sobrescreverInformacoesAction({Profissionais: data.Profissionais}))
                self.model.ProfissionaisOrcamentoSelecionados.removeAll();

                if (!self.model.ProfissionaisOrcamento() || self.model.ProfissionaisOrcamento().length == 0) {
                    self.model.incluir(true);
                }

            }
        });

    },

    salvar: function() {

        var self = this;

        var profissionais = this.toJS(this.model.ProfissionaisOrcamento());

        global.ajax({
            url: "/Orcamento/SalvarProfissionais",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                profissionais: profissionais
            }),
            success: function(data) {

                if (!data) {
                    return;
                }

                if (!data.HasErrors) {
                    global.showSuccessMessage("Profissional(is) atualizado(s) com sucesso");
                }

                var m = ko.mapping.fromJS(data.Profissionais);

                self.model.ProfissionaisOrcamento(m());
                self.orcamento.set("Profissionais", data.Profissionais);
                store.dispatch(sobrescreverInformacoesAction({Profissionais: data.Profissionais}))
                self.model.ProfissionaisOrcamentoSelecionados.removeAll();

                if (!self.model.ProfissionaisOrcamento() || self.model.ProfissionaisOrcamento().length == 0) {
                    self.model.incluir(true);
                }

            }
        });

    }


});

(window as any).ProfissionalOrcamentoController = ProfissionalOrcamentoController
